import React, { useState } from 'react';
import { Users, Shield } from 'lucide-react';
import PermissionsManagement from './PermissionsManagement';
import RolePermissions from './RolePermissions';
import './PermissionsTabs.css';

const PermissionsTabs = () => {
  const [activeTab, setActiveTab] = useState('users');

  return (
    <div className="permissions-tabs">
      <div className="tabs-header">
        <h1>Permissions Management</h1>
        <div className="tabs-navigation">
          <button
            className={`tab-button ${activeTab === 'users' ? 'active' : ''}`}
            onClick={() => setActiveTab('users')}
          >
            <Users size={16} />
            Users
          </button>
          <button
            className={`tab-button ${activeTab === 'roles' ? 'active' : ''}`}
            onClick={() => setActiveTab('roles')}
          >
            <Shield size={16} />
            Roles
          </button>
        </div>
      </div>
      
      <div className="tabs-content">
        {activeTab === 'users' && <PermissionsManagement />}
        {activeTab === 'roles' && <RolePermissions />}
      </div>
    </div>
  );
};

export default PermissionsTabs;
